/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_developer_dash_users_apply_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Aplicar filtros`
};

const en_developer_dash_users_apply_filters = /** @type {(inputs: {}) => string} */ () => {
	return `Apply filters`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const developer_dash_users_apply_filters = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.developer_dash_users_apply_filters(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("developer_dash_users_apply_filters", locale)
	if (locale === "es") return es_developer_dash_users_apply_filters(inputs)
	return en_developer_dash_users_apply_filters(inputs)
};
export { developer_dash_users_apply_filters as "developer.dash_users.apply_filters" }